import React from "react";
import { GamesAndLiveEventsHeader } from "./GamesAndLiveEventsHeader";
import { GamesAndLiveEventsBento } from "./GamesAndLiveEventsBento";
import { GamesAndLiveEventsTabs } from "./GamesAndLiveEventsTabs";
import { GamesAndLiveEventsStudentCarousel } from "./GamesAndLiveEventsStudentCarousel";

export const GamesAndLiveEventsOverview = () => {
  return (
    <>
      <GamesAndLiveEventsHeader />
      <div className="flex flex-col gap-6 p-6">
        <GamesAndLiveEventsBento />
        <GamesAndLiveEventsStudentCarousel />
        <div className="pt-2">
          <GamesAndLiveEventsTabs />
        </div>
      </div>
    </>
  );
};
